import { useContext, useState } from 'react';
import { SmartSendContext } from '../../lib/context/SmartSendContext';
import { Tagged } from '../Tagged';
import { CustomerAccountDetails } from './onboarding/CustomerAccountDetails';
import { Customer } from '~/lib/api/smartsend/types';
import { UpdateCustomerAction } from '../../lib/context/SmartSendContextModels';
import { CountryCache, GenCountryKey } from '../../lib/cache/CountryCache';
import { P2GBox, P2GText, P2GLink } from '@parcel2go/core-ui';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import { P2GSidePanel } from '~/components/sidepanel';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  isXs: boolean;
}

const DefaultCollectionAddress: React.FC<props> = (props) => {
  const { updateCustomer } = useSmartSendApi();
  const sctx = useContext(SmartSendContext);
  const [open, setOpen] = useState(false);
  const customer = sctx.state.customer;
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const saveCustomer = (customer: Customer) => {
    updateCustomer(customer.Id, customer);
    sctx.dispatch(new UpdateCustomerAction(customer));
    setOpen(false);
  };

  if (!customer) return null;

  return (
    <>
      <P2GBox textAlign="center" pt={2} pb={2}>
        <P2GText variant="body2">
          {t('DEFAULT_COLLECTION_ADDRESS', { defaultValue: 'Default Collection Address:' })}
          {props.isXs ? <br /> : ' '}
          <P2GLink onClick={() => setOpen(!open)} data-sentry-mask>
            {customer.AddressLine1} {customer.AddressLine2}, {customer.Postcode}
          </P2GLink>
        </P2GText>
      </P2GBox>
      <P2GSidePanel
        open={open}
        onClose={() => setOpen(false)}
        anchor="right"
        title={t('DEFAULT_COLLECTION_ADDRESS_SIDEPANEL_TITLE', { defaultValue: 'Default Collection Address' })}
        width="550px"
      >
        {open && (
          <Tagged tag="panel-default-customer">
            <P2GBox mb={2} p={2} bordered>
              <P2GText data-sentry-mask>
                <strong>{customer.Name}</strong>
                <br />
                {customer.AddressLine1} {customer.AddressLine2},<br />
                {customer.Postcode},<br />
                {CountryCache[GenCountryKey(customer)]?.LocalisedName}
              </P2GText>
            </P2GBox>
            <CustomerAccountDetails customerType="Sender" onSave={saveCustomer} customer={customer} loading={false} />
          </Tagged>
        )}
      </P2GSidePanel>
    </>
  );
};

export default DefaultCollectionAddress;
